module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA7UlEQVQoU52Sr07DUBjFf6cGRJdUkLRiYgI5MbO0PAIeUTs1gdgSEjIxUU1oQoIiGGTfgEdoCQaxB0BuehWoXdJu7bZ0Ixmfuvc795zvzz2iik50jmsPgRCpW6aNmQEJi/yF7+inSKkE+g8elvWO1KsFdg/GfLFaXfN5Pxdr5fTo44pYkBb5lfAfR0hPtWABSDZw2ahmzFj4cYoIdsAB82WCa9+CpghnK0YmgngJFIpVDMju3spLL3I4s1+RbjZg/jdhvYznfcKxlrzWCMOk2dKhoeECqX146FPW+pH3//FxDWsoRGyswQzMnjV+Af7VXyOXcTFlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/playback.png
// module id = 2d5w
// module chunks = 15